import '../assets/css/experience.css';
import Timeline from './Timeline';


const Experience = () => {


    return (
        <>
            <h1 className="heading">Experience</h1>
            <div className="experience-container">
                <Timeline />
            </div>
        </>
    );
}

export default Experience;
